import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyCommunicationRecipientUserApiService } from './company-communication-recipient-user-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyCommunicationRecipientUserApiService extends GeneratedCompanyCommunicationRecipientUserApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
